import bodyClass from "discourse/helpers/body-class";

export default <template>
  {{bodyClass "tags-page"}}
  {{outlet}}
</template>
